import SessionQ from '@/queries/SessionQ'
import TopicQ from '@/queries/TopicQ'
import { SQL, type SQLFragment } from '@/client/query'

import {
  LIVE_HELP_TOPIC,
  SESSION_ATTENDANCE_POLICIES,
  type SessionAttendancePolicy,
} from './constants'

// Filters out Live Help sessions, unless user is the tutor of the session.
export function filterAttendingLiveHelpSessions(
  userId: number | SQLFragment<number>
): SQLFragment<unknown> {
  return SQL`(${SessionQ.user_id} = ${userId} OR ${TopicQ.name} != ${LIVE_HELP_TOPIC})`
}

export function isSessionAttendancePolicy(
  attendancePolicy: string
): attendancePolicy is SessionAttendancePolicy {
  return SESSION_ATTENDANCE_POLICIES.some(policy => policy === attendancePolicy)
}
